<template>
  <div>
    <!--      当前报表分析-->
    <el-form :model='searchCondition' inline size='mini'>
      <el-form-item label='期望时间'>
        <el-date-picker
          v-model='searchCondition.date_range'
          placeholder='时间区间'
          type='daterange'
          align='right'
          unlink-panels
          range-separator='至'
          start-placeholder='开始日期'
          end-placeholder='结束日期'
          value-format='yyyy-MM-dd'
          :picker-options='pickerOptions' @change='handleQuery'>
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type='primary' icon='el-icon-search' @click='handleQuery' :disabled='loading' :loading='loading'>搜索</el-button>
      </el-form-item>
    </el-form>
    <div>
      <div>
        <div style='width: 100%;height: auto'>
          <!--              漏斗图-->
          <echarts-chart :width='chartWidth' :height='chartHeight' :chart-option='chartOption' @selectDetail="queryDetail" />
        </div>
      </div>
      <div>
        <el-dialog
          width="50%"
          :visible.sync='chartDetail.isShow'
          v-loading="chartDetail.loading"
          @close='chartDetailOnClose'
          :title='chartDetail.title'
          center>
          <!--          列表-->
          <div>
            <el-table :data="chartDetail.dataForm"
                      class="w-full"
                      :summary-method="getSummaries"
                      show-summary
                      border>
              <el-table-column type="index" label="序号" width="80" align="center" />
              <el-table-column prop="brand" label="品牌" align="center" />
              <el-table-column prop="ip_num" label="项目数量" width="100" align="right" />
              <el-table-column prop="order_num" label="订单数量" width="100" align="right" />
            </el-table>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import EchartsChart from '@/components/EchartsChart'


export default {
  name: 'chartStat',
  components: { EchartsChart },
  computed: {
    ...mapGetters(['userPermissions', 'userInfo'])
  },
  data() {
    return {
      loading: false,
      searchCondition: {date_range: []},
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一年',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      chartWidth: '100%',
      chartHeight: '800px',
      chartOption: {},
      legend: ['询单数量', '已下单询单', '未下单询单', '已下单品牌', '未下单品牌', '订单数量'],
      chartDetail: {
        isShow: false,
        loading: false,
        title: '',
        choiceField: '',
        queryForm: {},
        dataForm: [],
      },
    }
  },
  methods: {
    // 处理搜索条件
    handleSearchCondition() {
      const condition = {}
      Object.keys(this.searchCondition).forEach((field) => {
        if (this.searchCondition[field] && this.searchCondition[field].length > 0) {
          condition[field] = this.searchCondition[field]
        }
      })
      return condition
    },
    handleQuery() {
      this.getChatData()
    },
    async getChatData() {
      const params = this.handleSearchCondition()
      const { chart_data, legend } = await this.$api.getInquiryProjectOrderStat(params)

      this.initChart(legend, chart_data)
    },
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return false
        }
        if (['ip_num', 'order_num'].includes(column.property)) {
          const values = data.map(item => Number(item[column.property]))
          // console.log(values)
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev * 1 + curr * 1
              } else {
                return prev
              }
            }, 0)
            sums[index] += ''
          } else {
            sums[index] = 'N/A'
          }
        }
      })
      return sums
    },
    initChart(legend, seriesData) {
      // let { legend, seriesData } = this.calcChartData()
      this.chartOption = {
        color: [
          '#409EFF',
          '#3ac2bd',
          '#ad31ff',
          '#ff9a64',
          '#67C23A',
          '#2843cc'],
        title: {
          text: '询单数据漏斗图',
          textStyle: {
            color: '#ff3176',
            fontWeight: 'bold',
            fontSize: 20
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c}'
        },
        legend: {
          data: legend
        },
        series: [
          {
            name: '缇苏询单',
            type: 'funnel',
            left: 'center',
            top: 60,
            bottom: 60,
            width: '50%',
            minSize: '0%',
            maxSize: '100%',
            sort: 'descending',
            gap: 2,
            label: {
              show: true,
              position: 'inside',
              formatter: '{b} : {c}',
              color: '#f2f2f2',
              fontStyle: 'italic',
              fontSize: 14
            },
            labelLine: {
              length: 10,
              lineStyle: {
                width: 1,
                type: 'solid'
              }
            },
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 1
            },
            emphasis: {
              label: {
                fontSize: 20
              }
            },
            data: seriesData
          }
        ]
      }
    },
    queryDetail: async function(args) {
      if (!args.field) {
        this.$message.warning('图表数据包缺少必要参数[field]')
        return
      }
      const allowFields = ['order_brand_ip_num', 'not_order_brand_ip_num']
      if (!allowFields.includes(args.field)) {
        return
      }
      this.chartDetail.title = `${args.name}的统计明细`
      this.chartDetail.isShow = true
      this.chartDetail.choiceField = args.field
      // 获取数据
      await this.handleChartDetail()
    },
    chartDetailOnClose() {
      this.chartDetail.isShow = false
      this.chartDetail.loading = false
      this.chartDetail.title = ''
      this.chartDetail.queryForm = {}
      this.chartDetail.dataForm = []
    },
    handleChartDetail: async function() {
      // 打包明细查询条件
      this.chartDetail.queryForm = {...this.searchCondition, field: this.chartDetail.choiceField}
      // 开启加载状态
      this.chartDetail.loading = true
      // 请求接口
      const { list } = await this.$api.getInquiryProjectChartStatDetail(this.chartDetail.queryForm)
      this.chartDetail.dataForm = list
      // 关闭加载状态
      this.chartDetail.loading = false
    }
  },
  async created() {
    //默认时间
    const date = new Date()
    const currentDay = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    const monthFirstDay = `${date.getFullYear()}-${date.getMonth() + 1}-01`
    this.searchCondition.date_range = [monthFirstDay, currentDay]
    //再获取
    this.handleQuery()
  }
}
</script>

<style scoped>
</style>
